<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="no-arrow">当前位置：</el-breadcrumb-item>
      <transition-group name="breadcrumb">
        <template v-for="item in breadcrumbArr">
          <el-breadcrumb-item :key="item.path" :to="{path:item.path}">
            <span>{{item.meta.title}}</span>
          </el-breadcrumb-item>
        </template>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: "Breadcrumb",
    data() {
      return {
        breadcrumbArr: []
      }
    },
    watch: {
      "$route"() {
        this.getBreadcrumb();
      }
    },
    created() {
      this.getBreadcrumb();
    },
    methods: {
      //获取当前面包屑路径
      getBreadcrumb() {
        this.breadcrumbArr = this.$route.matched.filter(item => item?.meta?.title);
      }
    }
  }
</script>

<style lang="scss">
  .breadcrumb {
    display: inline-block;
    vertical-align: middle;
    .el-breadcrumb {
      .el-breadcrumb__item {
        &.no-arrow {
          .el-breadcrumb__separator {
            display: none;
          }
        }
        &:last-child {
          .el-breadcrumb__inner {
            color: $home-color;
            &:hover {
              color: $home-color;
            }
          }
        }
        .el-breadcrumb__inner {
          &.is-link {
            font-weight: 400;
          }
          a {
            font-weight: 400;
          }
        }
      }
    }
  }
  .breadcrumb-enter-active,
  .breadcrumb-leave-active {
    transition: all .5s;
  }
  .breadcrumb-enter,
  .breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(20px);
  }
  .breadcrumb-move {
    transition: all .5s;
  }
  .breadcrumb-leave-active {
    position: absolute;
  }
</style>
